import useQueryParam from './useQueryParam';
const useAmount = () => {
    const amount = useQueryParam('amount');
    if (amount) {
        return Number(amount);
    }
    return undefined;
};
export default useAmount;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQW1vdW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2hvb2tzL3F1ZXJ5cGFyYW1zL3VzZUFtb3VudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxhQUFhLE1BQU0saUJBQWlCLENBQUM7QUFFNUMsTUFBTSxTQUFTLEdBQUcsR0FBdUIsRUFBRTtJQUN2QyxNQUFNLE1BQU0sR0FBRyxhQUFhLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDdkMsSUFBSSxNQUFNLEVBQUUsQ0FBQztRQUNULE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzFCLENBQUM7SUFDRCxPQUFPLFNBQVMsQ0FBQztBQUNyQixDQUFDLENBQUM7QUFDRixlQUFlLFNBQVMsQ0FBQyJ9